import { Shelf } from "capitalrx-components-2.0/lib/layout";
import styled from "styled-components";

export const DetailSection = styled(Shelf)`
  border-bottom: solid 1px #313E48;
  padding-bottom: 8px;
`;
